import { Box, Button, Grow, Modal, Typography } from "@mui/material";
import "./catalogModal.css";

const CatalogModal = ({ openModal, handleClose, data, onAction }) => {
  const buttons = [
    {
      text: "No",
      color: "#E77B7B",
      action: handleClose,
    },
    {
      text: "Yes",
      color: "#50C878",
      action: () => {
        onAction(data);
        handleClose();
      },
    },
  ];

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Grow in={openModal}>
        <Box className="catalog-modal-body">
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
            }}
          >
            <Typography className="catalog-modal-heading">
              Create catalog for{" "}
              <strong style={{ textTransform: "capitalize" }}>
                {data?.clientName}
              </strong>{" "}
              order ?
            </Typography>
            <Box className="catalog-btn-modal">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  className="catalog-btn"
                  sx={{
                    backgroundColor: button.color,
                    minWidth: "11vw",
                    whiteSpace: "nowrap",
                  }}
                  onClick={button.action}
                >
                  {button.text}
                </Button>
              ))}
            </Box>
          </Box>
        </Box>
      </Grow>
    </Modal>
  );
};

export default CatalogModal;
